export default function cargoCarrier() {
	return {
		id: undefined,
		name: undefined,
		width: undefined,
		height: undefined,
		length: undefined,
		palletCapacity: undefined,
		registrationNumber: undefined,
		cargoCarrierType: undefined
	};
}
